// Carruseles de móvil (ST-10): flechas y avance solo. Cada .carrusel es una fila que
// se desliza con el dedo por debajo de 720 px; en pantalla grande es una rejilla y
// las flechas no salen. Se carga después de resenas.js, que rellena las reseñas.
(() => {
  const s = document.createElement('style');
  s.textContent = `
.carrusel-caja{position:relative}
.carrusel-flecha{display:none;position:absolute;top:34%;z-index:5;width:44px;height:44px;border-radius:50%;border:1px solid var(--linea);background:rgba(255,255,255,.94);color:var(--carbon);font:400 1.7rem/1 var(--letra);padding:0 0 3px;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.14);place-items:center}
.carrusel-flecha.ant{left:2px}.carrusel-flecha.sig{right:2px}
.carrusel-flecha:active{transform:scale(.94)}
@media(max-width:719px){.carrusel-flecha{display:grid}}`;
  document.head.appendChild(s);

  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.carrusel').forEach(c => {
    const caja = document.createElement('div');
    caja.className = 'carrusel-caja';
    c.before(caja); caja.appendChild(c);

    const paso = () => c.firstElementChild.offsetWidth + 12;
    const alFinal = () => c.scrollLeft + c.clientWidth >= c.scrollWidth - 4;
    const ir = dir => {
      if (dir > 0) alFinal() ? c.scrollTo({left: 0, behavior: 'smooth'}) : c.scrollBy({left: paso(), behavior: 'smooth'});
      else c.scrollLeft <= 4 ? c.scrollTo({left: c.scrollWidth, behavior: 'smooth'}) : c.scrollBy({left: -paso(), behavior: 'smooth'});
    };
    let parada = 0;
    [['ant', '‹', -1, 'Previous'], ['sig', '›', 1, 'Next']].forEach(([cl, txt, dir, et]) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'carrusel-flecha ' + cl; b.textContent = txt; b.setAttribute('aria-label', et);
      b.onclick = () => { parada = Date.now() + 10000; ir(dir); };
      caja.appendChild(b);
    });

    // Avanza solo cada 4,5 s mientras está a la vista; el usuario lo para al tocarlo
    if (quieto) return;
    let visible = false;
    new IntersectionObserver(([e]) => visible = e.isIntersecting, {threshold: .5}).observe(caja);
    const frena = () => parada = Date.now() + 10000;
    ['pointerdown', 'wheel', 'focusin'].forEach(ev => c.addEventListener(ev, frena, {passive: true}));
    setInterval(() => {
      if (visible && c.scrollWidth > c.clientWidth + 8 && Date.now() > parada) ir(1);
    }, 4500);
  });
})();
